import React from 'react';
import PropTypes from 'prop-types';
import LoadingIndicator from '../../../Common/LoadingIndicator/LoadingIndicator';
import * as types from '../../../../constants/actionTypes';
import Notification from '../../../Common/Notification';
import Button from '../../../Common/Button';
import TextArea from '../../../Common/TextArea';
import "./LocationNameForm.scss";

class LocationAttributesForm extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            searchResults: [],
            selectedResults: [],
            selectedToAdd: [],
            isLoading: false,
            searchParams: {
                subscriptionId: this.props.subscriptionId,
                projectKey: this.props.projectKey,
                term: "",
                isNameSearch: false
            }
        }
    }

    search = async () => {
        try {
            if (this.isSearchTermValid === false) {
                Notification("error", "Search Term", "The search term cannot be empty or exceed 3000 characters.")
                return;
            }

            this.setState({ isLoading: true });

            const request = {
                ...this.state.searchParams,
                searchTerms: this.searchTermsToArray(this.state.searchParams.term)
            }

            const result = await this.props.projectLocationActions.locationNameSearch(request);
            const payload = result.payload;
            if (result.type === types.SEARCH_PROJECTLOCATION_NAME_SUCCESS) {
                this.setState({ searchResults: payload.locations });
            } else if (result.type === types.SEARCH_PROJECTLOCATION_NAME_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    //we want the user to have the option of searching by a comma-delimited, space-delimited, or newline delimited list
    searchTermsToArray = (terms) => {

        if (!terms) {
            return [];
        }

        //name search does not include the ability to search by space seperated values
        if (terms.includes(',') || this.state.searchParams.isNameSearch === true) {
            return terms.split(',')
        }

        //if they copy/pasted from excel it will carry over newlines that need to be replaced with spaces
        terms = terms.replace(/\n/g, ' ');
        return terms.split(' ');
    }

    isSearchTermValid = () => {
        if (!this.state.searchParams.term  || this.state.searchParams.term.length < 1 || this.state.searchParams.term.length > 3000) {
            return false;
        }

        return true;
    }

    onChangeSearchBy = () => {
        this.setState({ searchParams: { ...this.state.searchParams, isNameSearch: !this.state.searchParams.isNameSearch } });
    }

    onTermChange = (e) => {
        this.setState({ searchParams: { ...this.state.searchParams, [e.target.name]: e.target.value } });
    }

    onSelectSearchResult = (e) => {
        const options = e.target.options;
        let selected = [];
        for (let i = 0; i < options.length; i++) {
            if (options[i].selected) {
                const value = options[i].value;
                const item = this.state.searchResults.find(x => x.id.toString() === value);
                selected.push(item);
            }
        }
        this.setState({ selectedResults: selected });
    }

    onSelectToAdd = (e) => {
        const options = e.target.options;
        let selected = [];
        for (let i = 0; i < options.length; i++) {
            if (options[i].selected) {
                const value = options[i].value;
                const item = this.state.searchResults.find(x => x.id.toString() === value);
                selected.push(item);
            }
        }
        this.setState({ selectedToAdd: selected });
    }

    onAllDown = () => {
        this.props.setSelectedLocations(this.state.searchResults.slice());
    }

    onAllUp = () => {
        this.props.setSelectedLocations([]);
    }

    onSomeDown = () => {
        let selected = this.props.selectedLocations.slice();

        for (let i = 0; i < this.state.selectedResults.length; i++) {
            const option = this.state.selectedResults[i];
            const item = this.props.selectedLocations.find(x => x.id === option.id);
            if (!item) {
                selected.push(option);
            }
        }
        this.props.setSelectedLocations(selected);
    }

    onSomeUp = () => {
        let selected = this.props.selectedLocations.slice();
        for (let i = 0; i < this.state.selectedToAdd.length; i++) {
            const option = this.state.selectedToAdd[i];
            const item = this.props.selectedLocations.find(x => x.id === option.id);
            const index = this.props.selectedLocations.indexOf(item);

            selected.splice(index, 1);

        }
        this.props.setSelectedLocations(selected);
    }

    renderResultList = () => {
        let options = [];
        this.state.searchResults.forEach(function (option) {
            options.push(
                <option key={option.id} value={option.id}>{option.name} ({option.abbreviation})</option>
            );
        });
        return options;
    }

    renderSelectedList = () => {
        let options = [];
        this.props.selectedLocations.forEach(function (option) {
            options.push(
                <option key={option.id} value={option.id}>{option.name} ({option.abbreviation})</option>
            );
        });
        return options;
    }

    render() {

        const searchByText = (this.state.searchParams.isNameSearch) ? "Search by Abbreviations" : "Search By Name";

        return (
            <LoadingIndicator isLoading={this.state.isLoading || this.props.isLoading}>
                <div className="row">
                    <div className="col-12 text-end">
                        <button type="button" className="btn btn-link" onClick={this.onChangeSearchBy}>{searchByText}</button>
                    </div>
                    <div className="col-12">
                        {this.state.searchParams.isNameSearch ?
                            <TextArea rows={5} maxLength={3000} name="term" label="Location Names Start With" type="text" placeholder="Hotel Alpha, Hotel Beta" value={this.state.searchParams.term} onChange={this.onTermChange} />
                        :
                            <TextArea rows={5} maxLength={3000} name="term" label="Location Abbreviations" type="text" placeholder="ABC, XYZ" value={this.state.searchParams.term} onChange={this.onTermChange} />
                        }
                    </div>
                    <div className="col-12 text-end">
                        <div className="input-subtitle">Separate multiple values with comma</div>
                    </div>
                </div>
                <div>
                    <div className="col-12 text-end">
                        <div className="search-button"><Button name="option2-search" text="Search" bootstrapClass="primary" type="button" onClick={this.search} /></div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <span className="has-float-label">
                            <select id="searchResultsList" className="form-control mt-3" multiple size="8" defaultValue={[]} onChange={this.onSelectSearchResult}>
                                {this.renderResultList()}
                            </select>
                            <p className="search-results-count">{this.state.searchResults.length} results</p>
                            <label htmlFor="searchResultsList">Search Results</label>
                        </span>
                    </div>
                </div>
                <br />
                <div className="row">
                    <div className="col-12 text-center">
                        <Button name="angle-double-down" text="" bootstrapClass="secondary me-4" type="button" onClick={this.onAllDown} iconName="angle-double-down" />
                        <Button name="angle-down" text="" bootstrapClass="secondary me-4" type="button" onClick={this.onSomeDown} iconName="angle-down" />
                        <Button name="angle-up" text="" bootstrapClass="secondary me-4" type="button" onClick={this.onSomeUp} iconName="angle-up" />
                        <Button name="angle-double-up" text="" bootstrapClass="secondary me-4" type="button" onClick={this.onAllUp} iconName="angle-double-up" />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <span className="has-float-label">
                            <select id="selectedList" className="form-control mt-3" multiple size="8" onChange={this.onSelectToAdd}>
                                {this.renderSelectedList()}
                            </select>
                            <label htmlFor="selectedList">Locations to Add</label>
                        </span>
                    </div>
                </div>
            </LoadingIndicator>
        );
    }
}

LocationAttributesForm.propTypes = {
    subscriptionId: PropTypes.string.isRequired,
    projectKey: PropTypes.string.isRequired,
    selectedLocations: PropTypes.array.isRequired,
    setSelectedLocations: PropTypes.func.isRequired,
    projectLocationActions: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired
};

export default LocationAttributesForm;
